import {create} from 'zustand';
import {DocumentData, DocumentSnapshot} from 'firebase/firestore';

type NewsStore = {
	news: DocumentSnapshot<DocumentData, DocumentData>[] | null;
	setNews: (
		newNews: DocumentSnapshot<DocumentData, DocumentData>[] | null,
	) => void;

	lastVisibleNews: DocumentSnapshot<DocumentData, DocumentData> | null;
	setLastVisibleNews: (
		newLastVisibleNews: DocumentSnapshot<DocumentData, DocumentData> | null,
	) => void;

	loadedAllNews: boolean;
	setLoadedAllNews: (loadedAllNews: boolean) => void;
};

export const useNewsStore = create<NewsStore>((set) => ({
	news: null,
	setNews: (
		newNews: DocumentSnapshot<DocumentData, DocumentData>[] | null,
	) => {
		set(() => ({news: newNews}));
	},

	lastVisibleNews: null,
	setLastVisibleNews: (
		newLastVisibleNews: DocumentSnapshot<DocumentData, DocumentData> | null,
	) => {
		set(() => ({lastVisibleNews: newLastVisibleNews}));
	},

	loadedAllNews: false,
	setLoadedAllNews: (newLoadedAllNews: boolean) => {
		set(() => ({loadedAllNews: newLoadedAllNews}));
	},
}));
